import styled from 'styled-components';

export const Container = styled.div`
    min-height: 370px;
    height: 100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content: center;
`;

export const Text1 = styled.div`
    margin-top: 38px;
    font-size: 24px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.black};
    line-height: 24.14px;
    text-align: center;

    @media (max-width: 960px) {
        margin-top: 21px;
        margin-left: 20px;
        margin-right: 20px;
    }
`;

export const Text2 = styled.div`
    max-width: 686px;
    margin-top: 16px;
    font-size: 20px;
    font-weight: 400;
    color: ${(props) => props.theme.colors.black};
    line-height: 26px;
    text-align: center;
    
    @media (max-width: 960px) {
        margin-left: 21px;
        margin-right: 21px;
    }
`;